import { render, staticRenderFns } from "./JdsTableCurrencyCell.vue?vue&type=template&id=68817637&scoped=true&"
import script from "./JdsTableCurrencyCell.vue?vue&type=script&lang=ts&"
export * from "./JdsTableCurrencyCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68817637",
  null
  
)

export default component.exports